import React, { Component } from 'react'


const Spinner = () => {
  
    return (
      <div className="text-center">
        <img className="my-3" src="/brooksroyale-logo.jpg" width="200px" alt="loading" />
      </div>
    )
  
}


export default Spinner